import React, { useState } from "react";
import { useNavigate } from "react-router";
import apiMethod from '../../../../services/api-service';
import methods from "../../../../services/utility";

// assets
import Preloading from '../../../../components/basics/Preloading';

const LoginForm = () => {

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const submitForm = async () => {
    if (!validLoginForm())
      return false;

    setLoading(true);

    try {
      const response = await apiMethod.getToken({
        username: username,
        password: password
      });

      if (response.status !== 200) {
        methods.showErrors(response.messages);
        return false;
      }

      methods.setToken(response.data);
      navigate(methods.routeAfterLogin());

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const validLoginForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(username)) {
      errors.push('نام کاربری باید مقدار داشته باشد.');
    }
    if (methods.isNullOrEmptyString(password)) {
      errors.push(' رمز عبور باید مقدار داشته باشد.');
    } else if (password.length < 6) {
      errors.push(' رمز عبور باید بیشتر از ۶ کاراکتر داشته باشد.');
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const renderLoginForm = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <div className="loginForm">
            <div className="row g-3 p-3">
              <p className="loginFormTitle">ورود</p>
              <div className="col-md-12">
                <label className="form-label"> شماره همراه خود را وارد کنید .</label>
                <input
                  className="form-control loginInputField"
                  type="text"
                  placeholder=". . . 09"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  autoComplete="off"
                  style={{ direction: 'rtl', textAlign: 'left' }}
                />
              </div>
              <div className="col-md-12">
                <label className="form-label">رمزعبور خود را وارد کنید .</label>
                <input
                  className="form-control loginInputField position-relative"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="off"
                  style={{ direction: 'rtl', textAlign: 'left' }}
                />
                {/* <i className={showPassword ? "bi bi-eye text-black" : "bi bi-eye-slash text-black"}
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ cursor: 'pointer', position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}
                ></i> */}
                <i
                  className={showPassword ? "bi bi-eye text-black loginPasswordIcon" : "bi bi-eye-slash text-black loginPasswordIcon"}
                  onClick={() => setShowPassword(!showPassword)}

                ></i>
              </div>
              <div className="col-md-12 mt-5">
                <button type="button" onClick={submitForm}
                  className="btn custome-btn btn-purple w-100">
                  ورود به نرم افزار
                </button>
              </div>
            </div>
          </div>
        }
      </>
    )
  };

  return (
    <>
      {renderLoginForm()}
    </>
  );
}

export default LoginForm;